<template>
  <div>
    <ItemPage
      title="Editar Atividade"
      size="sm"
      :actions="actions"
      :menu-actions="menuActions"
    >
      <v-form ref="form">
        <v-text-field
          v-model="activity.name"
          label="Nome"
          outlined
        />
        <v-text-field
          v-model="activity.url"
          label="URL"
          outlined
        />
        <v-text-field
          v-model="activity.cover_path"
          label="URL da capa"
          outlined
        />

        <v-textarea
          v-model="activity.description"
          counter
          label="Descrição"
          placeholder="Descreva este conteúdo"
          outlined
        />
      </v-form>

      <v-row
        class="mt-6"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="6"
        >
          <div class="font-weight-bold">
            Cursos
          </div>
          <div class="text-body-2 text--secondary mt-1">
            Essa atividade esta disponível para os cursos listados
          </div>
        </v-col>

        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            color="primary"
            text
            @click="openAddGradeDialog"
          >
            <v-icon left>
              mdi-plus
            </v-icon> Adicionar Curso
          </v-btn>
        </v-col>
      </v-row>

      <v-simple-table
        v-if="activity.grades.length > 0"
      >
        <thead>
          <tr>
            <th>Curso</th>
            <th class="text-right" />
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(grade, index) in activity.grades"
            :key="grade.id"
          >
            <td> {{ grade.short_name }} - {{ grade.education_stage.short_name }}</td>

            <td class="text-right">
              <v-btn
                small
                text
                @click="removeActivitieGrade(grade.id)"
              >
                <v-icon
                  small
                  left
                >
                  mdi-delete
                </v-icon>
                Remover
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </ItemPage>
  </div>
</template>

<script>
import AddGradeDialog from '@/components/contents/questions/AddGradeDialog.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
    ItemPage
  },
  mixins: [
    handlesServerValidation
  ],
  data () {
    return {
      name: '',
      activity: null
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },

    actions () {
      return [
        {
          label: 'Salvar',
          action: this.updateActivities,
          icon: 'mdi-floppy',
          disabled: false
        }
      ]
    },

    menuActions () {
      return [
        {
          label: 'Apagar',
          action: this.deleteActivities,
          icon: 'mdi-delete',
          disabled: false
        }
      ]
    }
  },

  created () {
    this.getActivities()
  },
  methods: {

    async getActivities () {
      this.loading = true
      this.loadingMsg = 'Carregando conteudo...'
      try {
        this.activity = await this.$api.getActivities(this.id)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter atividade, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
      this.loading = false
    },

    async updateActivities () {
      const data = {
        name: this.activity.name,
        url: this.activity.url,
        cover_path: this.activity.cover_path,
        description: this.activity.description
      }
      try {
        await this.$api.updateActivities(this.id, data)
        this.$store.dispatch('setSnackBar', { text: 'Atualizado com sucesso.' })
        await this.getActivities()
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
    },

    async deleteActivities () {
      this.$dialog.confirm('Apagar atividade?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.deleteActivities(this.id)
            this.$store.dispatch('setSnackBar', { text: 'Atividade excluida com sucesso.' })
            this.$router.back()
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível Excluir, tente novamente mais tarde.', color: 'red' })
            this.getErrors(e)
          }
        })
        .show()
    },

    openAddGradeDialog () {
      this.$dialog.custom(AddGradeDialog).show()
        .then(async (grade) => {
          if (!grade) {
            return
          }
          await this.addActivitieGrade(grade)
        })
    },
    async addActivitieGrade (grade) {
      try {
        await this.$api.addActivitieGrade(this.id, grade)
        await this.getActivities()
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível adicionar a atividade, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
    },
    async removeActivitieGrade (gradeId) {
      this.$dialog.confirm('Apagar curso?')
        .text('Tem certeza que deseja remover esta atividade do curso? Essa ação não pode ser desfeita.')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.removeActivitieGrade(this.id, gradeId)
            await this.getActivities()
            this.$store.dispatch('setSnackBar', { text: 'Atividade removida com sucesso.' })
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível remover a atividade, tente novamente mais tarde.', color: 'red' })
            this.getErrors(e)
          }
        })
        .show()
    }
  }
}
</script>
